import "./browser/index";
import registerServiceWorker from "./registerServiceWorker";

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js